import { render, staticRenderFns } from "./DownloadPost.vue?vue&type=template&id=1452f5da&scoped=true&"
import script from "./DownloadPost.vue?vue&type=script&lang=js&"
export * from "./DownloadPost.vue?vue&type=script&lang=js&"
import style0 from "./DownloadPost.vue?vue&type=style&index=0&id=1452f5da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1452f5da",
  null
  
)

export default component.exports